"use strict";
/*
 * Created on 02 08 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var index_1 = require("../../core/utils/index");

var OptimizationScenario_1 = require("../model/OptimizationScenario");

var OptimizationScenarioConverter_1 = require("./OptimizationScenarioConverter");

var OptimizationScenarioDataConverter_1 = require("./OptimizationScenarioDataConverter");
/**
 * @author Jaroslav Sevcik
 */


var OptimizationScenarioConverterImpl =
/*#__PURE__*/
function (_OptimizationScenario) {
  _inherits(OptimizationScenarioConverterImpl, _OptimizationScenario);

  function OptimizationScenarioConverterImpl(optimizationScenarioDataConverter, validationResultConverter) {
    var _this;

    _classCallCheck(this, OptimizationScenarioConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptimizationScenarioConverterImpl).call(this));
    _this.optimizationScenarioDataConverter = optimizationScenarioDataConverter;
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(OptimizationScenarioConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        categoryId: conversions.toDocumentReferenceId(source.categoryId),
        zoneId: conversions.toDocumentReferenceId(source.zoneId),
        batchComputationStart: conversions.fromDate(source.batchComputationStart),
        optimizationId: source.optimizationId,
        computationState: source.computationState,
        optimizationData: source.optimizationData && this.optimizationScenarioDataConverter.toDocument(source.optimizationData, conversions),
        validation: this.validationResultConverter.toDocument(source.validation, conversions)
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new OptimizationScenario_1.OptimizationScenario(conversions.documentToClassId(source), conversions.asObject(source, 'categoryId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'zoneId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.toDate(source.batchComputationStart), conversions.asObject(source, 'optimizationId', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asEnum(source.computationState, OptimizationScenario_1.OptimizationState), conversions.asObjectOpt(source, 'optimizationData', function (v) {
        return _this2.optimizationScenarioDataConverter.toObject(v, conversions);
      }), conversions.asObject(source, 'validation', function (v) {
        return _this2.validationResultConverter.toObject(v, conversions);
      }));
    }
  }]);

  return OptimizationScenarioConverterImpl;
}(OptimizationScenarioConverter_1.OptimizationScenarioConverter);

OptimizationScenarioConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [OptimizationScenarioDataConverter_1.OptimizationScenarioDataConverter, ValidationResultConverter_1.ValidationResultConverter])], OptimizationScenarioConverterImpl);
exports.OptimizationScenarioConverterImpl = OptimizationScenarioConverterImpl;